import { axiosInstance } from '@/modules/shared/lib/axios'
import { ImportedReward, Props } from './types'

export function uploadTimesheetFile({ companyId, file }: Props) {
  const formData = new FormData()
  formData.append('body', file)

  return axiosInstance.post<ImportedReward[]>(
    `/api/${companyId}/timesheet/fileUpload`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    },
  )
}
